import './Polyfill.js';
import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import request from 'superagent';
import LoginPage from './LoginPage.js';
import MainPage from './modules/main/MainPage.js';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            configs: {
                showPdms: false,
                showTempPdms: false
            }
        };
    }

    componentDidMount() {
        request.get('/api/getFeatureConfig')
            .end((error, response) => {
                if (!error && response.body) {
                    this.setState({configs: response.body});
                }
            });
    }

    render() {
        const configs = this.state.configs;
        return (
            <Router>
                <div>
                    <Switch>
                        <Route path="/login" component={LoginPage}/>
                        <Route render={(props) => (
                            <MainPage {...props} configs={configs} />
                        )}/>
                    </Switch>
                </div>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js